<p>{{(value ? 'Draft' : 'Sent') | translate}}</p>
